/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserListRequest {
    getFixupPrototypeFunction() { return UserListRequest.fixupPrototype; }

    static newInstance(model: Partial<UserListRequest>): UserListRequest {
        let obj = Object.assign(new UserListRequest(), model);
        UserListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserListRequest>): UserListRequest {
        if (!model) return null;
        return UserListRequest.newInstance(<UserListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserListRequest) {
        if (!obj) return;

        models.UserListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserListRequest): boolean {
        Object.setPrototypeOf(obj, UserListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.UserFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.UserSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.UserSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.UserFilters;

}
